{
  "customers": [
    {
      "customerId": "105",
      "firstName": "Christopher",
      "lastName": "Borchardt",
      "email": "christoph.borchardt@nitrex.com",
      "companyName": "Lorem Ipsum",
      "userReference": "christoph.borchardt@nitrex.com",
      "userId": "ecc9ac59-a1d2-4775-a4ef-d653aacc06e4",
      "project": {
        "type": "new",
        "last_updated": "2024-06-01T12:00:00Z",
        "created_at": "2025-01-01T12:00:00Z"
      },
      "license": {
        "licenseId": "1",
        "name": "License 1",
        "description": "Description of License 1",
        "status": "active",
        "validFrom": "2024-01-01T00:00:00Z",
        "validTo": "2027-01-01T00:00:00Z"
      },
      "sites": [
        {
          "siteId": "1",
          "name": "Site 1",
          "description": "Position of Site 1",
          "license_model": "monthly",
          "assets": [
            {
              "assetId": "1",
              "name": "Asset 1",
              "description": "Description of Asset 1",
              "type": "virtual_machine",
              "status": "active"
            }
          ]
        },
        {
          "siteId": "2",
          "name": "Site 2",
          "description": "Position of Site 2",
          "license_model": "monthly",
          "assets": [
            {
              "assetId": "1",
              "name": "Asset 1",
              "description": "Description of Asset 1",
              "type": "virtual_machine",
              "status": "active"
            },
            {
              "assetId": "2",
              "name": "Asset 2",
              "description": "Description of Asset 2",
              "type": "virtual_machine",
              "status": "active"
            }
          ]
        }
      ]
    },
    {
      "customerId": "100",
      "firstName": "Max",
      "lastName": "Mustermann",
      "email": "max.mustermann@nitrex.com",
      "companyName": "Max Mustermann GmbH",
      "userReference": "max.mustermann@nitrex.com",
      "userId": "ecc9ac59-a1d2-4775-a4ef-d653aacc06e4",
      "project": {
        "type": "new",
        "last_updated": "2024-06-01T12:00:00Z",
        "created_at": "2025-01-01T12:00:00Z"
      },
      "license": {
        "licenseId": "1",
        "name": "License 1",
        "description": "Description of License 1",
        "status": "active",
        "validFrom": "2024-01-01T00:00:00Z",
        "validTo": "2027-01-01T00:00:00Z"
      },
      "sites": [
        {
          "siteId": "1",
          "name": "Site 1",
          "description": "Position of Site 1",
          "license_model": "monthly",
          "assets": [
            {
              "assetId": "1",
              "name": "Asset 1",
              "description": "Description of Asset 1",
              "type": "virtual_machine",
              "status": "active"
            },
            {
              "assetId": "2",
              "name": "Asset 2",
              "description": "Description of Asset 2",
              "type": "virtual_machine",
              "status": "active"
            }
          ]
        },
        {
          "siteId": "2",
          "name": "Site 2",
          "description": "Position of Site 2",
          "license_model": "monthly",
          "assets": [
            {
              "assetId": "1",
              "name": "Asset 1",
              "description": "Description of Asset 1",
              "type": "virtual_machine",
              "status": "active"
            },
            {
              "assetId": "2",
              "name": "Asset 2",
              "description": "Description of Asset 2",
              "type": "virtual_machine",
              "status": "active"
            }
          ]
        }
      ]
    }
  ],
  "user": {
    "appPermissions": {
      "USER_MANAGEMENT": {
        "Write": "37fd013c-d653-45f8-9293-bb6d62d6af26",
        "Read": "37fd013c-d653-45f8-9293-bb6d62d6af26"
      },
      "LICENSE": {
        "Write": "9013dfdd-0554-4bb9-a396-e39d4f89f657",
        "Read": "9013dfdd-0554-4bb9-a396-e39d4f89f657"
      },
      "PRICING_CALCULATOR": {
        "Write": "9013dfdd-0554-4bb9-a396-e39d4f89f657",
        "Read": "9013dfdd-0554-4bb9-a396-e39d4f89f657"
      },
      "PRICING_CALCULATOR_SETTINGS": {
        "Write": "9013dfdd-0554-4bb9-a396-e39d4f89f657",
        "Read": "9013dfdd-0554-4bb9-a396-e39d4f89f657"
      }
    },
    "assetPermissions": [
      1,
      2,
      3,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      53,
      55,
      56,
      57,
      58,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80,
      81,
      82,
      83,
      85,
      86,
      87,
      88,
      89,
      90,
      91,
      93,
      94,
      95,
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105,
      106,
      107,
      108,
      109,
      110,
      111,
      112,
      113,
      114,
      115,
      116,
      117,
      118,
      119,
      120,
      121,
      122,
      123,
      124,
      125,
      126,
      127,
      128,
      129,
      130,
      131,
      132,
      133,
      134,
      135,
      136,
      137,
      138,
      139,
      140,
      141,
      142,
      143,
      144,
      145,
      146,
      147,
      148,
      149,
      150,
      151,
      152,
      153,
      154,
      155,
      156,
      157,
      158,
      159,
      160,
      161,
      162,
      163,
      164,
      165,
      166,
      167,
      168,
      169,
      170,
      171,
      172,
      173,
      174,
      175,
      176,
      177,
      178,
      179,
      180,
      181,
      182,
      183,
      184,
      185,
      190,
      203,
      209,
      212,
      227,
      228,
      229,
      230,
      231,
      233,
      234,
      235,
      236,
      237,
      238,
      239,
      240,
      241,
      242,
      243,
      244,
      245,
      246,
      247,
      248,
      249,
      250,
      251,
      252,
      253,
      255,
      257,
      259,
      260,
      261,
      262,
      263,
      264,
      265,
      266,
      267,
      268,
      269,
      270,
      271,
      272,
      273,
      274,
      275,
      276,
      277,
      279,
      281,
      283,
      285,
      287,
      289,
      291,
      293,
      294,
      295,
      296,
      297,
      298,
      299,
      300,
      301,
      302,
      303,
      304,
      305,
      306,
      307,
      308,
      309,
      310,
      311,
      312,
      313,
      314,
      315,
      316,
      317,
      318,
      319,
      320,
      321,
      323,
      325,
      327,
      329,
      331,
      333,
      335,
      337,
      339,
      340,
      341,
      342,
      343,
      344,
      345,
      346,
      347,
      348,
      349,
      350,
      351,
      352,
      353,
      354,
      355,
      356,
      357,
      358,
      359,
      360,
      361,
      362,
      363,
      364,
      365,
      366,
      367,
      368,
      369,
      370,
      371,
      372,
      373,
      374,
      375,
      377,
      379,
      381,
      383,
      385,
      386,
      387,
      388,
      389,
      390,
      391,
      392,
      393,
      394,
      395,
      396,
      397,
      398,
      399,
      400,
      401,
      402,
      403,
      404,
      405,
      406,
      407,
      408,
      409,
      410,
      411,
      413,
      415,
      417,
      420,
      421,
      422,
      435,
      436,
      438,
      440,
      445,
      446,
      447,
      448,
      449,
      450,
      451,
      452,
      454,
      455,
      456,
      458,
      459,
      460,
      461,
      462,
      463,
      464,
      465,
      466,
      467,
      468,
      470,
      475,
      479,
      482,
      484,
      485,
      486,
      488,
      514,
      601,
      602,
      603,
      604,
      605,
      606,
      607,
      608,
      609,
      610,
      611,
      612,
      613,
      614,
      615,
      616,
      617,
      618,
      619,
      620,
      621,
      622,
      623,
      624,
      625,
      626,
      627,
      628,
      629,
      630,
      631,
      632,
      633,
      634,
      635,
      636,
      637,
      638,
      640,
      641,
      642,
      643,
      648,
      -116,
      -115,
      -114,
      -113,
      -112,
      -111,
      -110,
      -109,
      -108,
      -106,
      -105,
      -104,
      -103,
      -102,
      -101,
      -100,
      -16,
      -15,
      -14,
      -13,
      -12,
      -11,
      -10,
      -9,
      -8,
      -7,
      -6,
      -5,
      -4,
      -3,
      -2,
      -1
    ],
    "userId": "57f6b8b8-9b8b-4f68-b842-1a6f0a5f47e4",
    "roles": [
      {
        "displayName": "💻 Developer (FULL ACCESS)",
        "description": "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.\n\nDuis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.\n\nUt wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi.",
        "isDefault": false,
        "roleId": "3e2c1aa2-f723-405b-91ba-239002d04f62"
      }
    ],
    "isDeleted": false,
    "firstName": "Christopher",
    "lastName": "Borchardt",
    "email": "christoph.borchardt@nitrex.com",
    "deletedAtUtc": null,
    "rolesDisplayName": [
      "💻 Developer (FULL ACCESS)"
    ],
    "hasCustomPermissions": false,
    "displayName": "Christopher Borchardt",
    "userReference": "christoph.borchardt@nitrex.com"
  },
  "apps": [
    {
      "appId": 1,
      "groupId": "e0a20aee-172d-42c8-9604-59e42510b2e9",
      "label": "License",
      "appGroupSemantic": "Configuration",
      "appGroupCommercial": "Settings",
      "permissions": [
        {
          "appId": 1,
          "permission": "Read",
          "appPermissionId": "37fd013c-d653-45f8-9293-bb6d62d6af26"
        },
        {
          "appId": 1,
          "permission": "Write",
          "appPermissionId": "37fd013c-d653-45f8-9293-bb6d62d6af26"
        }
      ]
    },
    {
      "appId": 2,
      "groupId": "769aa631-1006-4e0d-aeb8-94e8032963f4",
      "label": "Pricing Calculator",
      "appGroupSemantic": "Operation",
      "appGroupCommercial": "QmulusEssential",
      "permissions": [
        {
          "appId": 2,
          "permission": "Read",
          "appPermissionId": "9013dfdd-0554-4bb9-a396-e39d4f89f657"
        },
        {
          "appId": 2,
          "permission": "Write",
          "appPermissionId": "9013dfdd-0554-4bb9-a396-e39d4f89f657"
        }
      ]
    }
  ],
  "companies": [
    {
      "companyId": "12345",
      "created_at": "2025-01-01T12:00:00Z",
      "created_at_utc": "2025-01-01T12:00:00Z",
      "created_by": "12456",
      "last_modified_at": "2025-01-01T12:00:00Z",
      "last_modified_at_utc": "2025-01-01T12:00:00Z",
      "customerType": "NEW",
      "customerAge": 4,
      "companyName": "Lorem Ipsum GmbH",
      "email": "christoph.borchardt@nitrex.com",
      "street": "Musterstraße 42",
      "city": "Musterhausen",
      "zipcode": "01234",
      "country": "DE",
      "region": "NA",
      "currency": "EUR",
      "sites": [
        {
          "siteId": "123456",
          "displayName": "Site A",
          "description": "Lorem Ipsum"
        }
      ],
      "contacts": [
        {
          "contactId": "123456",
          "firstName": "Christopher",
          "lastName": "Borchardt",
          "email": "christoph.borchardt@nitex.com",
          "phone": "012456789",
          "description": "Salespartner"
        },
        {
          "contactId": "01234",
          "firstName": "Max",
          "lastName": "Mustermann",
          "email": "max.mustermann@nitex.com",
          "phone": "012456789",
          "description": "Techniker"
        }
      ],
      "projects": [
        {
          "projectId": "123456",
          "displayName": "Project A",
          "created_at": "2025-01-01T12:00:00Z",
          "created_at_utc": "2025-01-01T12:00:00Z",
          "created_by": "12456",
          "last_modified_at": "2025-01-01T12:00:00Z",
          "last_modified_at_utc": "2025-01-01T12:00:00Z",
          "currency": "EUR",
          "license": {
            "licenseId": "1",
            "licenseModel": "CLOUD",
            "duration": "60",
            "displayName": "License 1",
            "description": "Description of License 1",
            "hasIndividualPurchase": false,
            "hasSoftwareAgreement": false
          },
          "sites": [
            {
              "siteId": "0.7719958112422415",
              "contactId": "123456",
              "displayName": "Hall 1",
              "assets": [
                {
                  "assetId": "0.6076250643142916",
                  "assetType": "TYPE_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.31957592171173665",
                  "assetType": "TYPE_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.49955781612613737",
                  "assetType": "TYPE_III",
                  "assetValue": 0
                },
                {
                  "assetId": "0.07636607880154256",
                  "assetType": "CARS",
                  "assetValue": 0
                },
                {
                  "assetId": "0.555775163938431",
                  "assetType": "MAGAZINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.9418751495467057",
                  "assetType": "T_LINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.9753858256676402",
                  "assetType": "AUTOMAT_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.9753858256676402",
                  "assetType": "AUTOMAT_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.9753858256676402",
                  "assetType": "AUTOMAT_III",
                  "assetValue": 0
                }
              ]
            },
            {
              "siteId": "0.48735421235640497",
              "contactId": "01234",
              "displayName": "Hall 2",
              "assets": [
                {
                  "assetId": "0.2777217044968173",
                  "assetType": "TYPE_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.038737240936726924",
                  "assetType": "TYPE_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.9602572829419538",
                  "assetType": "TYPE_III",
                  "assetValue": 0
                },
                {
                  "assetId": "0.1666271990405137",
                  "assetType": "CARS",
                  "assetValue": 0
                },
                {
                  "assetId": "0.3129855498351768",
                  "assetType": "MAGAZINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.005661698067688015",
                  "assetType": "T_LINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.06256623541155637",
                  "assetType": "AUTOMAT_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.06256623541155631",
                  "assetType": "AUTOMAT_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.06256623541155632",
                  "assetType": "AUTOMAT_III",
                  "assetValue": 0
                }
              ]
            },
            {
              "siteId": "0.1607073359649248",
              "contactId": "01234",
              "displayName": "Hall 3",
              "assets": [
                {
                  "assetId": "0.04487268522219112",
                  "assetType": "TYPE_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.5827577219305019",
                  "assetType": "TYPE_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.43625556585300407",
                  "assetType": "TYPE_III",
                  "assetValue": 0
                },
                {
                  "assetId": "0.514906193738596",
                  "assetType": "CARS",
                  "assetValue": 0
                },
                {
                  "assetId": "0.31992599447711245",
                  "assetType": "MAGAZINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.025812293596373048",
                  "assetType": "T_LINES",
                  "assetValue": 0
                },
                {
                  "assetId": "0.09238596741826066",
                  "assetType": "AUTOMAT_I",
                  "assetValue": 0
                },
                {
                  "assetId": "0.09238596741826066",
                  "assetType": "AUTOMAT_II",
                  "assetValue": 0
                },
                {
                  "assetId": "0.09238596741826066",
                  "assetType": "AUTOMAT_III",
                  "assetValue": 0
                }
              ]
            }
          ],
          "modules": [
            "LITE"
          ]
        }
      ]
    }
  ],
  "settings": {
    "currency": "EUR",
    "deployments": [
      {
        "deploymentId": "123",
        "deploymentType": "CLOUD",
        "customerType": "NEW",
        "min": 1,
        "max": 1,
        "price": 7000
      },
      {
        "deploymentId": "1234",
        "deploymentType": "CLOUD",
        "customerType": "NEW",
        "min": 2,
        "max": 0,
        "price": 5500
      },
      {
        "deploymentId": "1235",
        "deploymentType": "CLOUD",
        "customerType": "EXISTING",
        "min": 1,
        "max": 1,
        "price": 5000
      },
      {
        "deploymentId": "12356",
        "deploymentType": "CLOUD",
        "customerType": "EXISTING",
        "min": 2,
        "max": 0,
        "price": 4000
      },
      {
        "deploymentId": "223",
        "deploymentType": "ON_PREMISE",
        "customerType": "NEW",
        "min": 1,
        "max": 1,
        "price": 9000
      },
      {
        "deploymentId": "2234",
        "deploymentType": "ON_PREMISE",
        "customerType": "NEW",
        "min": 2,
        "max": 0,
        "price": 7000
      },
      {
        "deploymentId": "22345",
        "deploymentType": "ON_PREMISE",
        "customerType": "EXISTING",
        "min": 1,
        "max": 1,
        "price": 6500
      },
      {
        "deploymentId": "22356",
        "deploymentType": "ON_PREMISE",
        "customerType": "EXISTING",
        "min": 2,
        "max": 0,
        "price": 5200
      }
    ],
    "applications": [
      {
        "applicationType": "ALARM_STATISTICS",
        "price": 50
      },
      {
        "applicationType": "ANOMALY_DETECTION",
        "price": 300
      },
      {
        "applicationType": "ASSET_MANAGEMENT",
        "price": 100
      },
      {
        "applicationType": "CERTIFICATION",
        "price": 50
      },
      {
        "applicationType": "CUSTOMER",
        "price": 10
      },
      {
        "applicationType": "HISTORY_AND_TRENDS",
        "price": 100
      },
      {
        "applicationType": "LIVE",
        "price": 100
      },
      {
        "applicationType": "MATERIALS",
        "price": 10
      },
      {
        "applicationType": "MODEL_BUILDER",
        "price": 100
      },
      {
        "applicationType": "OPERATION_CALENDAR",
        "price": 50
      },
      {
        "applicationType": "ORDERS",
        "price": 10
      },
      {
        "applicationType": "PARTS",
        "price": 10
      },
      {
        "applicationType": "PERFORMANCE_DASHBOARD",
        "price": 50
      },
      {
        "applicationType": "PRODUCTION_LOGS",
        "price": 150
      },
      {
        "applicationType": "PRODUCTION_STATISTICS",
        "price": 50
      },
      {
        "applicationType": "PT9800_CONFIGURATION",
        "price": 0
      },
      {
        "applicationType": "QMULUS_DASHBOARD",
        "price": 50
      },
      {
        "applicationType": "RECIPE",
        "price": 50
      },
      {
        "applicationType": "REMOTE_CONTROL",
        "price": 50
      },
      {
        "applicationType": "SHOP_LAYOUT",
        "price": 50
      },
      {
        "applicationType": "SIMULATOR",
        "price": 150
      },
      {
        "applicationType": "TENANT_SETTINGS",
        "price": 0
      },
      {
        "applicationType": "UPC_PRO",
        "price": 0
      },
      {
        "applicationType": "USER_MANAGEMENT",
        "price": 0
      }
    ],
    "modules": [
      {
        "moduleId": "123",
        "moduleType": "LITE",
        "TYPE_I": 30,
        "TYPE_II": 40,
        "TYPE_III": 100,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 45,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 115
      },
      {
        "moduleId": "1234",
        "moduleType": "ESSENTIAL",
        "TYPE_I": 30,
        "TYPE_II": 40,
        "TYPE_III": 100,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 45,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 115
      },
      {
        "moduleId": "1235",
        "moduleType": "OPERATIONS",
        "TYPE_I": 25,
        "TYPE_II": 40,
        "TYPE_III": 120,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 40,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 135
      },
      {
        "moduleId": "12356",
        "moduleType": "ANALYTICS",
        "TYPE_I": 25,
        "TYPE_II": 40,
        "TYPE_III": 120,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 40,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 135
      },
      {
        "moduleId": "12367",
        "moduleType": "AUDIT_QUALITY",
        "TYPE_I": 25,
        "TYPE_II": 40,
        "TYPE_III": 120,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 40,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 135
      },
      {
        "moduleId": "123687",
        "moduleType": "AI",
        "TYPE_I": 25,
        "TYPE_II": 40,
        "TYPE_III": 120,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 40,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 135
      },
      {
        "moduleId": "12311",
        "moduleType": "SIMULATOR",
        "TYPE_I": 25,
        "TYPE_II": 40,
        "TYPE_III": 120,
        "CARS": 75,
        "MAGAZINES": 5,
        "T_LINES": 30,
        "AUTOMAT_I": 40,
        "AUTOMAT_II": 55,
        "AUTOMAT_III": 135
      }
    ],
    "durations": [{
      "durationId": "123",
      "1": 70,
      "2": 60,
      "3": 50,
      "4": 40,
      "5": 50,
      "6": 0
    }]
  },
  "prices": {
  }
}